import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, Navigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Box, CircularProgress, Text } from '@chakra-ui/react';
import '../payment.css';

import CheckoutForm from "../components/ChackoutForm";
import { getPaymentConfig } from "../services/PaymentServices";

// loadStripe rejects on an empty key, so only call it once a key is known
let stripePromise = null;
const getStripe = (key) => {
    if (!stripePromise && key) stripePromise = loadStripe(key);
    return stripePromise;
};

const StripePayment = ({ price, address, publishableKey }) => {

    const [clientSecret, setClientSecret] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {

        fetch(`${process.env.REACT_APP_API_BASE_URL}/create-payment-intent`, {
            method: "POST",
            // fetch doesn't get axios' default headers, so pass the login token explicitly
            headers: { "Content-Type": "application/json", ...(axios.defaults.headers.common.Authorization && { Authorization: axios.defaults.headers.common.Authorization }) },
            body: JSON.stringify({ price }),
        })
            .then((res) => res.json())
            .then((data) => data.clientSecret ? setClientSecret(data.clientSecret) : setError(data.error || 'Could not start Stripe payment.'));
    }, [price]);

    const appearance = {
        theme: 'stripe',
    };
    const options = {
        clientSecret,
        appearance,
    };

    if (error || !publishableKey) {
        return <Text color='red.500' mt={10} >{error || 'Stripe is not configured. Set STRIPE_PUBLISHABLE_KEY in api/.env.'}</Text>
    }

    return (
        clientSecret && (
            <Elements options={options} stripe={getStripe(publishableKey)}>
                <CheckoutForm address={address} />
            </Elements>
        )
    )
}

const Payment = () => {

    const { state } = useLocation();
    const [config, setConfig] = useState(null);

    useEffect(() => {
        getPaymentConfig()
            .then(setConfig)
            .catch(() => setConfig({ provider: 'stripe' }));
    }, []);

    if (!state?.price) {
        return <Navigate to='/cart' />
    }

    return (
        <Box className="payment" display='flex' justifyContent='center' p={{ base: 0, md: 5 }} my={{ base: 5, md: 10 }} >
            {!config && <CircularProgress isIndeterminate color='raano.black' my={20} />}
            {/* Razorpay opens straight from the cart page */}
            {config?.provider === 'razorpay' && <Navigate to='/cart' />}
            {config?.provider === 'stripe' &&
                <StripePayment
                    price={state.price}
                    address={state.address}
                    publishableKey={config.stripePublishableKey || process.env.REACT_APP_STRIPE_API_KEY}
                />
            }
        </Box>
    )
}

export default Payment;
